import React from 'react'
import ButtonAction, { ButtonActionProps } from 'components/shared/ButtonAction'

const ConfirmButton: React.FC<Omit<ButtonActionProps, 'text'>> = ({ ...props }) => {
  return <ButtonAction text='Confirm' size='large' fullWidth bold {...props} />
}

export default ConfirmButton
